// removed by extract-text-webpack-plugin
module.exports = {"scrollingTextContainer":"_1nBNrOp9S2D3ON_iXkdVrs","scrollingText":"_2RVjZjwH9gMUfGCZy5kvZf","steadyText":"OsJYC91nWTrArE0XCQN5_","noBottomMargin":"_13uC-3El5JlTgqfsEsB8pL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ScrollingText/ScrollingText.css
// module id = 380
// module chunks = 0